<script lang="ts" setup>
// TODO: Move site name to appConfig
const siteName = 'Dashboards - GRIFFO';
useHead({
    titleTemplate: (title) => {
        return title ? `${title} - ${siteName}` : siteName;
    },
});
</script>

<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>
